<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('certificate_payments_report')"
                >
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('certificate_payments_report')"
                >
                </HeaderMobile>
            </template>
            <div class="row">
                <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                    <b-form-group :label="$t('period')">
                        <payment-periods-selectbox :multiple="true"
                            v-model="form.period_id">
                        </payment-periods-selectbox>
                    </b-form-group>
                </div>

                <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                    <b-form-group :label="$t('program')">
                        <certificate-center-certificate-selectbox v-model="form.certificate_id" :multiple="false"></certificate-center-certificate-selectbox>
                    </b-form-group>
                </div>

                <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                    <b-form-group :label="$t('student_numbers')">
                        <lined-textarea v-model="form.number"
                                        :nowrap="false"
                                        :disabled="false"
                                        :styles="{ height: '15em', resize: 'both' }">
                        </lined-textarea>
                    </b-form-group>
                </div>

                <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                    <b-form-group :label="$t('national_id')">
                        <lined-textarea v-model="form.national_id"
                                        :nowrap="false"
                                        :disabled="false"
                                        :styles="{ height: '15em', resize: 'both' }">
                        </lined-textarea>
                    </b-form-group>
                </div>

                <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                    <b-form-group :label="$t('payment_type_group')">
                        <parameter-selectbox code="payment_type_groups"
                                             :multiple="true"
                                             v-model="form.payment_type">
                        </parameter-selectbox>
                    </b-form-group>
                </div>

                <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                    <b-form-group :label="$t('payment_type')">
                        <payment-types-selectbox
                            :type="form.payment_type"
                            v-model="form.payment_type_id">
                        </payment-types-selectbox>
                    </b-form-group>
                </div>

                <div class="col-12">
                    <b-row>
                        <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                            <b-form-group :label="$t('transaction_start_date')">
                                <select-date v-model="form.start_date" />
                            </b-form-group>
                        </div>

                        <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                            <b-form-group :label="$t('transaction_end_date')">
                                <select-date v-model="form.end_date" />
                            </b-form-group>
                        </div>
                    </b-row>
                </div>

                <div class="col-12">
                    <b-row>
                        <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                            <b-form-group :label="$t('created_at_start')">
                                <select-date v-model="form.created_at_start" />
                            </b-form-group>
                        </div>

                        <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                            <b-form-group :label="$t('created_at_end')">
                                <select-date v-model="form.created_at_end" />
                            </b-form-group>
                        </div>
                    </b-row>
                </div>

                <div class="col-12">
                    <b-row>
                        <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                            <b-form-group :label="$t('due_date_start')">
                                <select-date v-model="form.due_date_start" />
                            </b-form-group>
                        </div>

                        <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                            <b-form-group :label="$t('due_date_end')">
                                <select-date v-model="form.due_date_end" />
                            </b-form-group>
                        </div>
                    </b-row>
                </div>
                <div class="col-12">
                    <b-row>
                        <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                            <b-form-group :label="$t('payment_date_start')">
                                <select-date v-model="form.payment_date_start" />
                            </b-form-group>
                        </div>

                        <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                            <b-form-group :label="$t('payment_date_end')">
                                <select-date v-model="form.payment_date_end" />
                            </b-form-group>
                        </div>
                    </b-row>
                </div>

                <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                    <b-form-group :label="$t('include_cancelled')">
                        <b-form-checkbox v-model="form.include_cancelled" />
                    </b-form-group>
                </div>

                <div class="col-12 col-sm-6">
                    <ValidationProvider name="type" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('payment_or_refund')">
                            <multi-selectbox :allow-empty="true" :multiple="false"
                                             :validate-error="errors[0]" :options="typeOptions"
                                             v-model="form.type"></multi-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </div>

                <div class="col-12 col-sm-6">
                    <ValidationProvider name="response_type" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('report_type')">
                            <multi-selectbox :allow-empty="false" :multiple="false"
                                             :validate-error="errors[0]" :options="responseTypeOptions"
                                             v-model="form.response_type"></multi-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <processing-button @click="report" label="get_report"
                                       :processing="processing"></processing-button>
                </div>

            </div>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import PaymentPeriodsSelectbox from "@/components/interactive-fields/PaymentPeriodsSelectbox";
import PaymentProductsSelectbox from "@/components/interactive-fields/PaymentProductsSelectbox";
import PaymentPlanTypesSelectbox from "@/components/interactive-fields/PaymentPlanTypesSelectbox";
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";
import PaymentProgramLevelSelectbox from "@/components/interactive-fields/PaymentProgramLevelSelectbox";
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox";
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
import PaymentService from "@/services/PaymentService";
import DatatableFilter from '@/components/datatable/DatatableFilter';
import Datatable from '@/components/datatable/Datatable';
import PaymentTypeTypeSelectbox from "@/components/interactive-fields/PaymentTypeTypeSelectbox";
import PaymentTypesSelectbox from "@/components/interactive-fields/PaymentTypesSelectbox";
import TrueFalseSelectbox from "@/components/interactive-fields/TrueFalseSelectbox";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox";
import ProcessingButton from "@/components/elements/ProcessingButton";
import qs from "qs";
import StudentGroupSelectbox from "@/components/interactive-fields/StudentGroupSelectbox.vue";
import LinedTextarea from "@/components/elements/LinedTextarea.vue";
import CertificateCenterCertificateSelectbox
    from "@/components/interactive-fields/CertificateCenterCertificateSelectbox.vue";
import CertificatePaymentService from "@/services/CertificatePaymentService";

export default {
    components: {
        CertificateCenterCertificateSelectbox,
        LinedTextarea,
        StudentGroupSelectbox,
        ProcessingButton,
        MultiSelectbox,
        TrueFalseSelectbox,
        PaymentTypesSelectbox,
        PaymentTypeTypeSelectbox,
        AppLayout,
        Header,
        HeaderMobile,
        ValidationProvider,
        ValidationObserver,
        PaymentPeriodsSelectbox,
        PaymentProductsSelectbox,
        PaymentPlanTypesSelectbox,
        FacultySelectbox,
        ProgramSelectbox,
        PaymentProgramLevelSelectbox,
        SemestersSelectbox,
        ParameterSelectbox,
        DatatableFilter,
        Datatable
    },
    data() {
        return {
            responseTypeOptions: [
                {value: 'page', text: this.$t('page')},
                {value: 'excel', text: this.$t('excel')},
            ],
            typeOptions: [
                {value: 'payment', text: this.$t('collection')},
                {value: 'refund', text: this.$t('refund')},
            ],
            form: {response_type:'page'},
            processing:false
        }
    },
    metaInfo() {
        return {
            title: this.$t("certificate_payments_report")
        }
    },
    methods: {
        async report() {
            let data = {...this.form};
            let numbers=data.number;
            if(numbers){
                data.number=data.number.split(/\n/);
            }
            let nationalIds=data.national_id;
            if(nationalIds){
                data.national_id=data.national_id.split(/\n/);
            }
            let config = {
                params: {
                    filter:data
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            let isArrayBuffer=false;
            if (this.form.response_type == 'excel') {
                config.responseType = 'arraybuffer';
                isArrayBuffer=false;
            }
            this.processing=true;
            CertificatePaymentService.report(config)
                .then(response=>{
                    if (this.form.response_type == 'page') {
                        this._openFile(response);
                    } else if (this.form.response_type == 'excel') {
                        this._downloadFile(response, 'Tahsilat Raporu.xlsx');
                    }
                })
                .catch(e => {
                    this.showErrors(e, null, isArrayBuffer);
                })
                .finally(()=>{
                    this.processing=false
                    this.form.number=numbers;
                    this.form.national_id=nationalIds;
                });
        },
    }
}
</script>
